//entry point for header application
///<reference path="../vue-shim.d.ts" />
import Vue from 'vue';
import app from './Components/app.vue';
import { MemberBaseData } from 'shared/Models/memberClasses';

import BagPriceMain from "./BagPrice/BagPriceMain.vue";


let model = {
    member: new MemberBaseData(),
    ready: false
}

let headerVue = new Vue({
    el: "#header",
    data: model,
    components: { app }
});


const bagPriceElement = document.getElementById('APO_bagPrice');

if(bagPriceElement) {
    let bagPriceVue = new Vue({
        el: bagPriceElement,
        template: "<bag-price-main></bag-price-main>",
        components: { BagPriceMain }
    })
}